
import input from '~/plugins/mixins/input';

export default {
  mixins: [input],
  props: {
    name: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    checkboxValue: {
      type: [Number, String, Object],
      default: null,
    },
    labelLeft: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    spaceBetween: {
      type: Boolean,
      default: true,
    },
  },
};
